import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { bodyScrollLock } from '@scramble/utils';
import { LanguageSwitcher } from '@scramble/ui';
import Logo from '@scramble/design-system/logo/scramble_logo_white.svg';
import IconBurger from '@scramble/design-system/icons/menu-01.svg?react';
import IconClose from '@scramble/design-system/icons/x-close.svg?react';
import { MobileNavigationProps } from '../../types';
import { Navigation } from '../../navigation';
import { UserMenu } from '../../user';
import s from './index.module.scss';

export const MobileNavigation = ({
  menu,
  user,
  dropdownMenu,
  currentLocale,
  onLocaleChange,
}: MobileNavigationProps): JSX.Element => {
  const location = useLocation();
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    bodyScrollLock(isOpen);
  }, [isOpen]);

  useEffect(() => {
    setIsOpen(false)
  }, [location.pathname]);

  return (
    <>
      <div className={s.wrapper}>
        <div className="g-container">
          <img className={s.logo} src={Logo} alt="logo" width={112} height={20} />
          <div className={s.controls}>
            <div className={s.locale_switcher}>
              <LanguageSwitcher currentLocale={currentLocale} onLocaleChange={onLocaleChange} />
            </div>
            <button className={s.button} onClick={() => setIsOpen(true)}>
              <IconBurger />
            </button>
          </div>
        </div>
      </div>
      {isOpen && (
        <div className={s.menu}>
          <div className={s.sidebar}>
            <div className={s.content}>
              <div className={s.top}>
                <button className={s.btn_close} onClick={() => setIsOpen(false)}>
                  <IconClose />
                </button>
              </div>
              <div className={s.navigation}>
                <Navigation menu={menu} />
              </div>
              <UserMenu user={user} dropdownMenu={dropdownMenu} />
            </div>
          </div>
        </div>
      )}
    </>
  );
};
